import { Button, Divider, Grid, GridCol, Heading } from '@flixbus/honeycomb-react';
import { Link } from 'react-router-dom';
import AddVoucherTemplates, { AddVoucherTemplatesType } from '../../routes/AddVoucherTemplates';

import styles from './voucher-actions.module.scss';
import { Icon, IconUpload } from '@flixbus/honeycomb-icons-react';

const PageList = () => {
  const title: Record<AddVoucherTemplatesType['type'], string> = {
    marketing: 'Marketing',
    finance: 'Finance',
    'customer-service': 'Customer Service',
    'flix-benefit': 'Flix Benefit',
    operations: 'Operations',
    'ux-research': 'UX Research',
  };

  const renderLinks = (type: AddVoucherTemplatesType['type']) => (
    <>
      <div>
        <Heading size={4} Elem='span' extraClasses={styles.subtitle}>
          {title[type]}
        </Heading>
      </div>
      {AddVoucherTemplates.filter(e => e.type === type).map(e => (
        <Button
          key={`link-${e.path}`}
          Elem='a'
          small
          appearance='link'
          RouterLink={Link}
          to={e.path}
        >
          {e.name}
        </Button>
      ))}
    </>
  );

  return (
    <div>
      <div className={styles.header}>
        <Heading size={2}>Select a voucher type</Heading>
        <Button Elem='a' small appearance='link' RouterLink={Link} to='/upload-csv'>
          Upload CSV
          <Icon size={4} InlineIcon={IconUpload} />
        </Button>
      </div>
      <Divider extraClasses={styles.pageListDivider} />
      <Grid>
        <GridCol extraClasses={styles.col}>
          {renderLinks('customer-service')}
          {renderLinks('finance')}
        </GridCol>
        <GridCol extraClasses={styles.col}>
          {renderLinks('marketing')}
          {renderLinks('ux-research')}
          {renderLinks('operations')}
          {renderLinks('flix-benefit')}
        </GridCol>
      </Grid>
    </div>
  );
};

export default PageList;
